<template>
  <div v-if="big_flag">
    <div>
            <span><i class="fa fa-asterisk text-danger font10 ml-1"
                     aria-hidden="true"></i>所在平台</span>
      <el-select v-model="value_canter" placeholder="请选择" style="margin-left:180px"
                 @change="choicePlat" value-key="id">
        <el-option
            v-for="item in platform_data_list"
            :key="item.id"
            :label="item.name"
            :value="item.id">
        </el-option>
      </el-select>
    </div>
    <div style="margin-top: 10px" v-if="$store.state.project_data.object_data!==undefined">
            <span><i class="fa fa-asterisk text-danger font10 ml-1"
                     aria-hidden="true"></i>项目名称</span>
      <el-input style="margin-left:180px;width: 200px" size=""
                v-model=" $store.state.project_data.object_data.name"
                placeholder="请输入内容"></el-input>
    </div>
    <div class="card-body">
      <div class="row height100">
        <div class="col-lg-4  h-30">
          <div>
            <div class="card-header bg-info2 text-white">项目信息</div>
            <div style="">
              <el-form class="form mt-3" @submit.native.prevent
                       style="height: 600px">
                <div class="h-30">
                  <div v-if="region">
                    <EnumrTemp ref="region"></EnumrTemp>
                  </div>
                  <div v-for="(item,index) in project_attr_list" :key="index">
                    <equip_attr_temp
                        :Data="{'data':item,'attr':{'objType':'project'}}"
                    ></equip_attr_temp>
                  </div>
                </div>
              </el-form>
            </div>
          </div>
        </div>
        <div class="col-lg-4  h-30">
          <div>
            <div class="card-header bg-info2 text-white">
              <span>项目数据库信息</span>
            </div>
            <div style="height: 600px">
              <el-form class="form mt-3" @submit.native.prevent>
                <div v-for="(item,index) in $store.state.project_data.database_obj" :key="index">
                  <div>
                    <Input ref="chirld" :Data="{index:index,'data':item}"
                           @dataBase="get_dataBase"
                           v-if="db_flag"></Input>
                  </div>
                  <i class="el-icon-remove" v-if="$store.state.project_data.database_obj.length>2"
                     @click="remove_input_List_length(index)"></i>
                </div>
              </el-form>
              <div>
                <i class="el-icon-circle-plus"
                   @click="add_input_List_length"></i>

              </div>
            </div>

          </div>
        </div>
        <div class="col-lg-4  h-30">
          <div>
            <div class="card-header bg-info2 text-white">配置项目关系</div>
            <div class="card  h50">
              <div class="row p-3">
                <div class="col-lg-12">
                  <span v-if="platform_Id===''">
                    请先选择所在平台！
                  </span>
                  <div v-if="platform_Id!==''" class="mb-2">
                    <label class="col-sm-4  text-lr">
                      <i class="fa fa-asterisk text-danger font10 ml-1" aria-hidden="true"></i>
                      选择功能模块及权限 ：</label>
                    <span v-if="func_flag" class="col-sm-7">
                          <el-badge :value="checked_list.length" :hidden="checked_list.length===0" class="item "
                                    type="primary">
                         <el-dropdown trigger="click" class="item ">
                   <el-button type="primary" size="small">选择功能模块及权限</el-button>
                    <el-dropdown-menu slot="dropdown" style="min-width: 300px;max-height: 400px;overflow-y: scroll">
                      <el-tree :data="func_list" :show-checkbox="true"
                               @check-change="get_data" node-key="id" :props="props"
                               :default-checked-keys="checked_list"
                               ref="tree" class="filter-tree" accordion :check-strictly="true"
                      ></el-tree>
                    </el-dropdown-menu>
                  </el-dropdown>
                          </el-badge>
                      </span>
                    <div class=" row mb-2">
                      <label class="col-sm-4  text-lr lh40"> <i class="fa fa-asterisk text-danger font10 ml-1"
                                                                aria-hidden="true"></i>新项目管理员：</label>
                      <div class="col-sm-7 flex1 lh35">
                        <el-select v-model="new_manager" placeholder="请选择"
                                   @change="handleNodeClick" value-key="id">
                          <el-option
                              v-for="item in options"
                              :key="item.id"
                              :label="item.name"
                              :value="item">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
                <el-button @click="clearData">取 消</el-button>
                <el-button type="primary" @click="to_save">提 交</el-button>
              </span>
      </div>

    </div>
  </div>
</template>
<script>
import Input from "@/components/IBMS/function/general_func_group/new_input"
import EnumrTemp from "@/components/IBMS/function/special_func_group/area_select"
import equip_attr_temp from "@/components/IBMS/function/special_func_group/equip_attr_temp";

export default {
  name: "temp_dia",
  components: {
    Input, EnumrTemp,
    equip_attr_temp
  },
  props: [
    'Data'
  ],
  data() {
    return {
      value_canter: '',
      input_type_name: '',
      project_attr_list: [],
      disabled_list: ['311001', '311002', '311003', '311005', '311006', '311007', '311008', '311009', '311010', '311011'],
      temp_list: [{'index': 0}],
      flag: true,
      type: 0,
      pro_name: '',//项目名称
      data_base_list: [{
        database_name: '',
        database_ip: '',
        database_port: '',
        database_user: '',
        database_passwd: '',
        database_server_name: '',
        database_type: '',
        remark: '',
        real_ip: '',
        real_port: '',
      }],
      show_flag: this.Data.type,
      platform_name: '',
      platform_Id: '',
      platform_TableData: [],
      check_flag: true,
      role_id: this.$store.state.role_id,
      func_list: [],
      user_list: [],
      after_user_list: [],
      checked_func_list: [],
      func_flag: false,
      db_flag: true,
      platform_data_list: [],
      options: [],
      new_manager: '',
      props: {
        children: 'children',
        label: 'chinese_name',
        id: 'id'
      },
      region: true,
      checked_list: [],
      big_flag: true,
      link_user: [],
      users_flag: true,

    }
  },
  computed: {
    // get_project_list() {
    // return this.$store.state.project_data.filter(obj => {
    //   if (this.disabled_list.indexOf(obj.c_code) === -1) {
    //     return obj
    //   }
    // })
    // },
  },
  mounted() {
    this.query_list()
    console.log(this.Data, 'p0987')
    this.region = true

    var arry = []
    arry = this.$store.state.project_data.object_data.static_attribute
    arry.filter(obj => {
      if (this.disabled_list.indexOf(obj.c_code) === -1) {
        this.project_attr_list.push(obj)
      }
    })
    if (this.show_flag !== 0) {
      this.value_canter = this.$store.state.project_data.object_data.platform_id
      this.platform_Id = this.$store.state.project_data.object_data.platform_id
      this.checked_list = this.$store.state.project_data.func_id_list
      // this.link_user = this.$store.state.project_data.object_data.link_user


      // this.new_manager=this.$store.state.project_data.new_manager
      this.query_role_to_user()
      this.query_role_to_func_auth()

    }
  },
  created() {

  },
  methods: {
    get_dataBase(data, index) {
      console.log(data, index)
      this.$store.state.project_data.database_obj[index] = data
    },
    //选择新项目管理员
    handleNodeClick(data) {
      console.log(data)
      this.users_flag = false
      // if(data.order_count!==undefined){
      this.$store.state.project_data.new_manager = data.id
      // this.$store.state.project_data.object_data.link_user = [data.id]
      // this.link_user = [data.id]
      this.new_manager = data.name
      this.$nextTick(() => {
        this.users_flag = true
      })
      // }
    },
    to_save() {
      if (this.show_flag === 0) {
        this.save_project()
      } else {
        this.edit_project()
      }
    },
    //保存、编辑项目
    edit_project() {
      let check = this.$check_data([this.$store.state.project_data.object_data.static_attribute])
      if (!check) return
      var arry = this.$store.state.project_data.database_obj
      for (let i in arry) {
        if (arry[i].database_name === '' || arry[i].database_ip === '' || arry[i].database_port === ''
            || arry[i].database_user === '' || arry[i].database_passwd === '' || arry[i].database_server_name === ''
            || arry[i].database_type === '' || arry[i].real_ip === '' || arry[i].real_port === '') {
          this.$message({
            type: 'error',
            message: '请填写数据库完整信息'
          });
          return;
        }
      }
      if (this.$store.state.project_data.func_id_list.length === 0) {
        this.$message({
          type: 'error',
          message: '请选择功能模块及权限'
        });
        return;
      }
      this.$store.state.project_data.object_data.platform_id = this.platform_Id
      this.fullscreenLoading = true
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/Public/UpdateObject',
        data: {
          "version": "V1.1",
          "timestamp": "0",
          "data": {
            "object_data": this.$store.state.project_data
          }
        },
      }).then((response) => {
        this.fullscreenLoading = false
        if (response.data.result === 200) {
          this.$message({
            type: 'success',
            message: '操作成功'
          });
          this.$store.commit('set_project_data', [])
          this.$emit("show_dia", false)
          // this.$store.commit('data_base_data', this.data_base_list)

          this.query_project_list()
        } else {
          this.$message({
            type: 'error',
            message: '未知异常'
          });
        }
      })
    },
    //保存、编辑项目
    save_project() {
      let check = this.$check_data([this.$store.state.project_data.object_data.static_attribute])
      if (!check) return
      var arry = this.$store.state.project_data.database_obj
      for (let i in arry) {
        if (arry[i].database_name === '' || arry[i].database_ip === '' || arry[i].database_port === ''
            || arry[i].database_user === '' || arry[i].database_passwd === '' || arry[i].database_server_name === ''
            || arry[i].database_type === '' || arry[i].real_ip === '' || arry[i].real_port === '') {
          this.$message({
            type: 'error',
            message: '请填写数据库完整信息'
          });
          return;
        }
      }
      if (this.$store.state.project_data.func_id_list.length === 0) {
        this.$message({
          type: 'error',
          message: '请选择功能模块及权限'
        });
        return;
      }
      if (this.new_manager==='') {
        this.$message({
          type: 'error',
          message: '请选择新项目管理员'
        });
        return;
      }

      this.$store.state.project_data.object_data.platform_id = this.platform_Id
      this.fullscreenLoading = true
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/Public/AddNewObject',
        data: {
          "version": "V1.1",
          "timestamp": "0",
          "data": {
            "object_data": this.$store.state.project_data
          }
        },
      }).then((response) => {
        this.fullscreenLoading = false
        if (response.data.result === 200) {
          this.$message({
            type: 'success',
            message: '操作成功'
          });
          this.$store.commit('set_project_data', [])
          this.$emit("show_dia", false)
          // this.$store.commit('data_base_data', this.data_base_list)

          this.query_project_list()
        } else {
          this.$message({
            type: 'error',
            message: '未知异常'
          });
        }
      })
    },
    //选择平台
    choicePlat(data) {
      this.check_flag = false
      this.platform_Id = data
      this.query_role_to_user()
      this.query_role_to_func_auth()
      this.check_flag = true
    },
    //查询平台列表
    query_plat_list() {
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'global/platform/query',
        data: {
          "version": "V1.1",
          "timestamp": "0",
          "data": {
            "page": 1,
            "pagesize": 9999,
          }
        },
      }).then((response) => {
        for (let i in response.data.content.data_list) {
          if (response.data.content.data_list[i].platform_id !== "10-0000000000000000") {
            this.platform_TableData.push(response.data.content.data_list[i])
          }
        }
        console.log(this.platform_TableData, '0255s')
        // this.platform_TableData = response.data.content.data_list
        for (let i in this.platform_TableData) {
          if (this.Data.plat === this.platform_TableData[i].name) {
            this.value_canter = this.platform_TableData[i].name
            this.platform_Id = this.platform_TableData[i].platform_id
          }
        }
        this.query_role_to_user()
        this.query_role_to_func_auth()

      })
    },
    add_input_List_length() {
      var len = this.temp_list.length
      this.temp_list.push({'index': len})
      this.$store.state.project_data.database_obj.push({
        database_name: '',
        database_ip: '',
        database_port: '',
        database_user: '',
        database_passwd: '',
        database_server_name: '',
        database_type: '',
        remark: '',
        real_ip: '',
        real_port: '',

      })
    },
    remove_input_List_length(index) {
      // var len = this.temp_list.length
      // this.temp_list.splice(len - 1, 1)
      this.$store.state.project_data.database_obj.splice(index, 1)
    },
    //查询角色关联功能及权限
    //type:2:当前角色关联功能权限树，1：选中角色关联功能及权限id查询
    query_role_to_func_auth() {
      this.func_flag = false
      this.$axios({
        method: 'get',
        url: this.IBMS_API + 'IBMS/Public/QueryObjectTree',
        params: {
          'object_code': '63',
        }
      }).then((response) => {
        console.log(response.data)
        // if (type === 2) {
        this.func_list = response.data.content
        // this.checked_func_list = response.data.content
        this.func_flag = true

        // } else {
        //     this.checked_func_list = response.data.content
        //     this.func_flag = false
        //     this.$nextTick(() => {
        //         this.func_flag = true
        //     })
        // }
      })
    },
    //平台列表
    query_list() {
      this.$axios({
        method: 'get',
        url: this.IBMS_API + 'IBMS/Public/QueryObjectList',
        params: {
          'object_code': '10'
        },
      }).then((response) => {
        this.platform_data_list = response.data.content.data
        console.log(response.data.content, '778')
      })
    },
    //查询角色下级关联所有用户(面板用户列表)
    query_role_to_user() {
      this.user_list = []
      this.$axios({
        method: 'get',
        url: this.IBMS_API + 'IBMS/Public/QueryObjectTree',
        params: {
          object_code: '10',
          need_user_tree: '1',
        },
      }).then((response) => {
        // var arry=[{'id':'','name':'未分级用户','children':response.data.content[1].user_list}]
        // var list = this.r_user(response.data.content[0])
        this.options = response.data.content[0].user_list


        if (this.show_flag !== 0) {//编辑平台时-项目管理员以及排除
          this.users_flag = false
          for (let i in this.options) {
            if (this.options[i].id === this.$store.state.project_data.new_manager) {
              this.new_manager = this.options[i].name
            }
          }
          this.$nextTick(() => {
            this.users_flag = true

          })
        }


      })
    },
    get_data() {
      let temp = this.$refs.tree.getCheckedNodes(false, true)
      let list = temp.map(item => item.id)
      this.checked_list = list
      this.$store.state.project_data.func_id_list = list
    },
    get_user_data(data) {
      console.log(data, 'po')
      // this.$store.state.project_data.object_data.link_user = data
    },
    clearData() {
      // this.region=false
      this.$store.commit('set_project_data', [])
      this.$emit("show_dia", false)
    }

  }
}
</script>

<style scoped>

</style>